// extracted by mini-css-extract-plugin
module.exports = {"ratingWrapper":"m5bnIh2u","ratingLabel":"RBBJ7z0d"};